import { stringify } from "query-string";

import { IQueryParams } from "./IQueryParams";

export const buildUrl = <Params = IQueryParams>(
  path: string,
  params?: Params
) => {
  if (!params) {
    return path;
  }
  return `${path}?${stringify(params, { arrayFormat: "comma" })}`;
};
